/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_W1Inputs */

const en_mk_cmp_linear_w1 = /** @type {(inputs: Mk_Cmp_Linear_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team is product or engineering and the workflow already fits Linear.`)
};

const id_mk_cmp_linear_w1 = /** @type {(inputs: Mk_Cmp_Linear_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim Anda adalah tim produk atau engineering dan alur kerjanya sudah rapi di Linear.`)
};

/**
* | output |
* | --- |
* | "Your team is product or engineering and the workflow already fits Linear." |
*
* @param {Mk_Cmp_Linear_W1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_w1 = /** @type {((inputs?: Mk_Cmp_Linear_W1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_W1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_w1(inputs)
	return en_mk_cmp_linear_w1(inputs)
});